export default __webpack_public_path__ + "static/media/blog.62819093.jpg";